import React from 'react';

import * as PaymentsActions from './actions';
import * as PaymentsConstants from './constants';
import * as D from './deps';
import PartnerUpgradeReducer from './reducers/partnerUpgradeReducer';
import PaymentsReducer from './reducers/paymentsReducer';
import PaypalReducer from './reducers/paypalReducer';
import PersistedPaymentsReducer from './reducers/persistedPaymentsReducer';
import SourceReducer from './reducers/sourceReducer';
import Watchers from './sagas/watchers';
import * as PaymentsSelectors from './selectors';
import * as PaymentsUtils from './utils';

export default D.createDomainModule({
  name: PaymentsConstants.DOMAIN_NAME,
  components: {
    AnonUpgrade: props => {
      return (
        <D.AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_anon-upgrade" */ './components/Upgrade/AnonUpgrade',
            )
          }
        />
      );
    },
    PaymentsLoading: props => {
      return (
        <D.AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_payments_loading" */ './components/PaymentsLoading/PaymentsLoading',
            )
          }
        />
      );
    },
    Payments: props => {
      return (
        <D.AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_payments" */ './components/Upgrade/Payments/Payments',
            )
          }
        />
      );
    },
    Subscription: props => {
      return (
        <D.AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_subscription" */ './components/Subscription/Subscription',
            )
          }
        />
      );
    },
    SubscriptionModal: props => {
      return (
        <D.AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_subscription-modal" */ './components/Subscription/SubscriptionModal',
            )
          }
        />
      );
    },
    Upgrade: props => {
      return (
        <D.AsyncComponent
          {...props}
          importer={() =>
            System.import(/* webpackChunkName: "c_upgrade" */ './components/Upgrade/Upgrade')
          }
        />
      );
    },
    AnonUpgradeCards: props => {
      return (
        <D.AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_upgrade-card" */ './components/AnonUpgradeCards/AnonUpgradeCards',
            )
          }
        />
      );
    },
    UpgradeSplash: props => {
      return (
        <D.AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_upgrade-splash" */ './components/Upgrade/Splash/UpgradeSplash',
            )
          }
        />
      );
    },
    WelcomeMobile: props => {
      return (
        <D.AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_welcome-mobile" */ './components/WelcomeMobile/WelcomeMobile',
            )
          }
        />
      );
    },
    MobileMessage: props => {
      return (
        <D.AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_mobile-message" */ './components/MobileMessage/MobileMessage',
            )
          }
        />
      );
    },
    OnboardingDisclaimer: props => {
      return (
        <D.AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_onboarding-disclaimer" */ './components/OnboardingDisclaimer/OnboardingDisclaimer',
            )
          }
        />
      );
    },
    ProcessSpecialOffer: props => {
      return <D.AsyncDomain domain='specialOffers' component='ProcessSpecialOffer' props={props} />;
    },
    CongratulationsPage: props => {
      return <D.AsyncDomain domain='specialOffers' component='CongratulationsPage' props={props} />;
    },
    Redeem: props => {
      return <D.AsyncDomain domain='specialOffers' component='Redeem' props={props} />;
    },
    ProcessFamilyPlanAcceptInvite: props => {
      return (
        <D.AsyncDomain
          domain='familyPlanAcceptInvite'
          component='ProcessFamilyPlanAcceptInvite'
          props={props}
        />
      );
    },
  },
  constants: PaymentsConstants,
  utils: PaymentsUtils,
  selectors: PaymentsSelectors,
  actions: PaymentsActions,
  reducer: {
    userSettings: PaymentsReducer,
    userSettingsPersisted: PersistedPaymentsReducer,
    source: SourceReducer,
    paypal: PaypalReducer,
    partnerUpgrade: PartnerUpgradeReducer,
  },
  persisted: true,
  persistedReducers: ['userSettingsPersisted', 'source', 'paypal', 'partnerUpgrade'],
  onLoad() {},
  onStart() {
    this.registeredHandlers = D.registerHandlers(Watchers);
  },
  onStop() {
    D.removeAndStopHandlers(this.registeredHandlers, this.name);
  },
});
